import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "fkpi_session";

export const getSession = () => {
  try {
    return JSON.parse(localStorage.getItem(SESSION_KEY));
  } catch {
    return null;
  }
};
export const setSession = (s) => localStorage.setItem(SESSION_KEY, JSON.stringify(s));
export const clearSession = () => localStorage.removeItem(SESSION_KEY);

const authHeaders = () => {
  const s = getSession();
  return s ? { Authorization: `Bearer ${s.token}` } : {};
};

axios.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401 && getSession() && !e.config?.url?.includes("/auth/login")) {
      clearSession();
      window.location.reload();
    }
    return Promise.reject(e);
  }
);

export const api = {
  login: (payload) => axios.post(`${API}/auth/login`, payload).then((r) => r.data),
  getConfig: () => axios.get(`${API}/config`).then((r) => r.data),
  getDay: (date, warehouse) => axios.get(`${API}/days/${date}/${warehouse}`).then((r) => r.data),
  getDeliveries: (date, warehouse) =>
    axios.get(`${API}/deliveries`, { params: { date, warehouse } }).then((r) => r.data),
  addDelivery: (payload) =>
    axios.post(`${API}/deliveries`, payload, { headers: authHeaders() }).then((r) => r.data),
  updateDelivery: (id, payload) =>
    axios.put(`${API}/deliveries/${id}`, payload, { headers: authHeaders() }).then((r) => r.data),
  deleteDelivery: (id) =>
    axios.delete(`${API}/deliveries/${id}`, { headers: authHeaders() }).then((r) => r.data),
  closeDay: (date, warehouse) =>
    axios.post(`${API}/days/close`, { date, warehouse }, { headers: authHeaders() }).then((r) => r.data),
  reopenDay: (date, warehouse) =>
    axios.post(`${API}/days/reopen`, { date, warehouse }, { headers: authHeaders() }).then((r) => r.data),
  getLogins: () => axios.get(`${API}/logins`, { headers: authHeaders() }).then((r) => r.data),
  logReportView: (date) =>
    axios.post(`${API}/report-view`, { date }, { headers: authHeaders() }).then((r) => r.data).catch(() => {}),
  setProcessed: (date, warehouse, payload) =>
    axios.put(`${API}/days/processed`, { date, warehouse, ...payload }, { headers: authHeaders() }).then((r) => r.data),
  setOverflow: (date, warehouse, estimated_overflow) =>
    axios.put(`${API}/days/overflow`, { date, warehouse, estimated_overflow }, { headers: authHeaders() }).then((r) => r.data),
  setPallets: (date, warehouse, payload) =>
    axios.put(`${API}/days/pallets`, { date, warehouse, ...payload }, { headers: authHeaders() }).then((r) => r.data),
  getCaptures: (date, warehouse, kind = "osd") =>
    axios.get(`${API}/captures`, { params: { date, warehouse, kind } }).then((r) => r.data),
  uploadCapture: (formData) =>
    axios.post(`${API}/captures`, formData, { headers: authHeaders() }).then((r) => r.data),
  deleteCapture: (id) =>
    axios.delete(`${API}/captures/${id}`, { headers: authHeaders() }).then((r) => r.data),
  captureImageUrl: (id) => `${API}/captures/${id}/image`,
  getArchives: () => axios.get(`${API}/archives`).then((r) => r.data),
  getReport: (date) => axios.get(`${API}/report/${date}`).then((r) => r.data),
  resendReport: (date) =>
    axios.post(`${API}/reports/${date}/notify?force=true`, {}, { headers: authHeaders() }).then((r) => r.data),
  getMonthReport: (month) => axios.get(`${API}/report/month/${month}`).then((r) => r.data),
  csvUrl: (date) => `${API}/report/${date}/csv`,
  pdfUrl: (date) => `${API}/report/${date}/pdf`,
  downloadFile: async (url, filename) => {
    const r = await axios.get(url, { responseType: "blob" });
    const blobUrl = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
  },
};
